import { AllowSchema, DATA, StringSchema } from "shelving";
import { MUTE_MEMBER } from "shared/api";
import { Form, SelectField, SubmitButton, TextAreaField } from "shared/react";
import { ProfileCard } from "../profile/ProfileCard.js";
import { callAPI } from "../util/api.js";

const MUTE_SCHEMA = DATA({
	days: new AllowSchema({
		title: "How long",
		allow: [
			[1, "1 day"],
			[3, "3 days"],
			[7, "7 days"],
			[30, "30 days"],
			[365, "365 days"],
		],
	}),
	why: new StringSchema({ title: "Reason", min: 1 }),
});

export function MemberMuteForm({ gid, uid }: { gid: string; uid: string }): React.ReactElement {
	return (
		<Form schema={MUTE_SCHEMA} onSubmit={({ days, why }) => callAPI(MUTE_MEMBER, { gid, uid, days, why })}>
			<h2>Mute member</h2>
			<ProfileCard uid={uid} />
			<SelectField name="days" />
			<TextAreaField name="why" />
			<SubmitButton>Mute member</SubmitButton>
		</Form>
	);
}
